import React, { useEffect, useState } from "react";
import { Wrapper } from "../../Wrapper";

import { Switcher } from "../../Switcher";

import { Questions } from "../Questions";
import { Results } from "./Results";

import { Test as TestStyled } from "../Test";

export const Test = ({ questions, answers, ...props }) => {
  const [active, setActive] = useState(0);
  const [results, setResults] = useState([]);
  const answered = results.length === questions[active].length;

  useEffect(() => {
    setResults([]);
  }, [active]);

  return (
    <Wrapper>
      <TestStyled {...props}>
        {answered ? (
          <Results
            {...{
              questions: questions[active],
              results,
              setResults,
              active,
              answers,
            }}
          >
            <Switcher state={[active, setActive]} />
          </Results>
        ) : (
          <Questions {...{ questions: questions[active], results, setResults }}>
            <Switcher state={[active, setActive]} />
          </Questions>
        )}
      </TestStyled>
    </Wrapper>
  );
};
